import React from 'react';
import {Field} from 'redux-form';
import FormField from 'components/FormField';
import {CheckBoxField} from 'components/Fields';
import {splitListBy} from 'utils/common';
import ThreeStateCheckBox from 'components/ThreeStateCheckBox';

const onSelectAll = (deselected, changePermissionField) => {
  deselected.forEach(permission => {
    changePermissionField({id: `permissions.${permission.value}`, value: true});
  });
};

const onDeselectAll = (selected, changePermissionField) => {
  selected.forEach(permission => {
    changePermissionField({
      id: `permissions.${permission.value}`,
      value: false
    });
  });
};

const ThreeStateCheckBoxWrapper = ({
  namespace,
  selectedPermissions,
  changePermissionField
}) => {
  const [selected, deselected] = splitListBy(
    namespace.value,
    entity => selectedPermissions && !!selectedPermissions[entity.value]
  );
  return (
    <ThreeStateCheckBox
      className="selectAll"
      selected={selected.length > 0}
      deselected={deselected.length > 0}
      onSelectAll={() => onSelectAll(deselected, changePermissionField)}
      onDeselectAll={() => onDeselectAll(selected, changePermissionField)}
    />
  );
};

const PermissionsNamespace = ({
  header,
  permissions,
  selectedPermissions,
  changePermissionField
}) => (
  <div className="permissionNamespace">
    <div className="header">
      <div className="heading">{header}</div>
    </div>
    <div className="content">
      {permissions.map(namespace => (
        <div className="permissionsSection" key={namespace.uuid}>
          <div className="header">
            <div className="heading">{namespace.label}</div>
            <ThreeStateCheckBoxWrapper
              namespace={namespace}
              changePermissionField={changePermissionField}
              selectedPermissions={selectedPermissions}
            />
          </div>
          <div className="content">
            {namespace.value.map(permission => (
              <div className="row" key={permission.uuid}>
                <FormField>
                  <Field
                    name={`permissions.${permission.value}`}
                    component={CheckBoxField}
                    label={permission.label}
                  />
                </FormField>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PermissionsNamespace;
